var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStakingReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.958V16C25 20.0501 20.0751 22.875 14 22.875C7.92487 22.875 3 20.0501 3 16V12.958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.6667C20.0751 19.6667 25 16.3834 25 12.3333C25 8.28325 20.0751 5 14 5C7.92487 5 3 8.28325 3 12.3333C3 16.3834 7.92487 19.6667 14 19.6667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5335L14.178 15.9725L17.356 13.5335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1998 15.203L14.1998 9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingReward);
export default __webpack_public_path__ + "static/media/staking-reward.c6f5623b445b3ca15250b68cecc13da9.svg";
export { ForwardRef as ReactComponent };